
const periods = {
  SEVEN: 7,
  FIFTEEN: 15,
  THIRTY: 30,
  ONE_HUNDRED_EIGHTY: 180,
  THREE_HUNDRED_SIXTY_FIVE: 365,
  ALL: -1,
};

export default periods;
